exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fixed[data-v-3c1c9eda]{position:fixed;bottom:0;margin:20px}.left[data-v-3c1c9eda]{left:0}.right[data-v-3c1c9eda]{right:0}.center[data-v-3c1c9eda]{left:50%;transform:translateX(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c1c9eda","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Fixed.vue
// module id = 1052
// module chunks = 0